import { render, staticRenderFns } from "./ModalSelecionaEmpresa.vue?vue&type=template&id=548bb62c"
import script from "./ModalSelecionaEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports